import { isIElementAreaSectionWithUrl } from "@custom-types/i-elements-type-guards";
import { isIElementAttachment } from "@faro-lotv/ielement-types";
import { addIElements } from "@faro-lotv/project-source";
import { upsertSlideNodes } from "@store/slide-nodes/slide-nodes-slice";
import { downloadSlideNodes } from "@store/slide-nodes/slide-nodes-slice-utils";
/**
 * Fetches what the side panel shows of an annotation. Its ancestors, children and slide nodes go
 * to the store, while its attachments are returned, as only their group is kept in the store.
 *
 * @returns the attachments of the annotation, the newest first
 */
export function fetchMarkupSidePanelData({
  markupId,
  projectApiClient
}) {
  return async dispatch => {
    const [ancestors, descendants] = await Promise.all([projectApiClient.getAllIElements({
      descendantIds: [markupId]
    }), projectApiClient.getAllIElements({
      ancestorIds: [markupId]
    })]);
    const children = [];
    const attachments = [];
    for (const descendant of descendants) {
      if (isIElementAttachment(descendant)) {
        attachments.push(descendant);
      } else {
        children.push(descendant);
      }
    }
    const slideNodes = (await Promise.all(ancestors.filter(isIElementAreaSectionWithUrl).map(section => downloadSlideNodes(section.metaDataMap.slideNodesUrl)))).flat();
    dispatch(upsertSlideNodes(slideNodes));
    dispatch(addIElements([...ancestors, ...children]));
    return attachments.sort((attachmentA, attachmentB) => new Date(attachmentB.createdAt).getTime() - new Date(attachmentA.createdAt).getTime());
  };
}

/** @returns whether two lists hold the same attachments, unchanged */
export function isSameAttachments(previous, next) {
  return previous.length === next.length && previous.every((attachment, index) => attachment.id === next[index].id && attachment.modifiedAt === next[index].modifiedAt);
}